/* eslint-disable @typescript-eslint/naming-convention */
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from '@redux-saga/core';
import rootReducers from './rootReducer';
import rootSaga from './rootSaga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
	reducer: rootReducers,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				// Ignore these paths in the state for non-serializable date objects
				ignoredPaths: [
					'featureDateRangeSlice.vesselLocationsDate.specificDate',
					'featureDateRangeSlice.analysisDateRange.dateRange',
				],
				// Ignore these action types that contain non-serializable data
				ignoredActions: [
					'featureDateRange/setDateRange',
					'featureDateRange/initializeDateRangeFromMainMap',
				],
			},
		}).concat(sagaMiddleware),
	devTools: process.env.NODE_ENV !== 'production',
});

sagaMiddleware.run(rootSaga);

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
